import React from 'react';
import { graphql } from 'gatsby';
import { Container } from 'components/UI/Container/Container';
import { Grid, GridRow, GridCol } from 'components/UI/Grid';
import { PrismicLink } from 'components/PrismicLink';
import { AlternateLanguage, PageContextType } from '../types';
import withLayout from './withLayout';
import './PageNotFound.scss';

export type PageNotFoundDataType = {
    lang: string;
    alternate_languages: AlternateLanguage[];
    data: {
        not_found_small_text: string | null;
        not_found_large_text: string | null;
        not_found_button_text: string | null;
        not_found_button_link: {
            url: string;
        } | null;
    };
};

export type PageNotFoundTemplateProps = {
    location: Location;
    pageContext: PageContextType;

    data: {
        prismic404Page: PageNotFoundDataType;
    };
};

class PageNotFoundTemplate extends React.Component<PageNotFoundTemplateProps, {}> {
    render() {
        const page = this.props.data.prismic404Page;

        return (
            <Container className="PageNotFound" size="lg">
                <Grid>
                    <GridRow horizontalAlign="h-center">
                        <GridCol className="PageNotFound-content">
                            <p className="PageNotFound-secondaryText">
                                {page.data.not_found_small_text}
                            </p>
                            <p className="PageNotFound-primaryText">
                                {page.data.not_found_large_text}
                            </p>
                            {page.data.not_found_button_link && (
                                <PrismicLink
                                    link={page.data.not_found_button_link}
                                    className="Button Button--primary Button--small"
                                >
                                    <div className="Button-wrapper">
                                        <div className="Button-text">
                                            {page.data.not_found_button_text}
                                        </div>
                                    </div>
                                </PrismicLink>
                            )}
                        </GridCol>
                    </GridRow>
                </Grid>
            </Container>
        );
    }
}

export const pageQuery = graphql`
    query($id: String!) {
        prismic404Page(id: { eq: $id }) {
            type
            lang
            first_publication_date
            last_publication_date
            alternate_languages {
                lang
                type
                id
            }
            data {
                not_found_small_text
                not_found_large_text
                not_found_button_text
                not_found_button_link {
                    url
                }
            }
        }
    }
`;

export default withLayout(PageNotFoundTemplate);
